/* CADEME v33 (31 Ekim 2026) - Alt yapiskan "Sepete Ekle" cubugu.
   Eski davranis: urun sessizce sepete ekleniyor, ekranda hicbir geri bildirim olmuyordu.
   Yeni davranis: cubuk, ana urun formunun butonunu kullanir; sepet cekmecesi acilir,
   sepet ikonu guncellenir. Tema 4 sn icinde yanit vermezse sepet sayfasina gidilir. */
(function () {
  if (window.__cademeStickyAtc) return;
  window.__cademeStickyAtc = true;

  var CART_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart';

  function findRoot(el) {
    var n = el;
    while (n && n !== document) {
      if (n.tagName && n.tagName.indexOf('STICKY-ADD-TO-CART-') === 0) return n;
      n = n.parentNode;
    }
    return null;
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('button[class*="sticky-add-to-cart-"][class*="__add-button"]') : null;
      if (!btn || btn.disabled) return;
      var root = findRoot(btn);
      if (!root) return;
      if (root.querySelector('[data-variant-select]')) return; // cok varyantli urun: eski akis

      var mainForm = document.querySelector('product-form-component form[data-type="add-to-cart-form"]');
      var mainButton = mainForm ? mainForm.querySelector('button[type="submit"]') : null;
      if (!mainButton || mainButton.disabled) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var qtyInput = root.querySelector('input[type="number"]');
      var quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var mainQty = mainForm.querySelector('input[name="quantity"]');
      if (mainQty) {
        mainQty.value = quantity;
        mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Ekleniyor…';

      var settled = false;
      function finish(text) {
        if (settled) return;
        settled = true;
        document.removeEventListener('cart:update', onUpdate);
        document.removeEventListener('cart:error', onError);
        btn.textContent = text;
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        }, 2500);
      }
      function onUpdate(ev) {
        var d = ev && ev.detail && ev.detail.data;
        finish(d && d.didError ? 'Eklenemedi' : '✓ Sepete eklendi');
      }
      function onError(ev) {
        var m = ev && ev.detail && ev.detail.data && ev.detail.data.message;
        finish(m ? String(m).slice(0, 40) : 'Eklenemedi');
      }
      document.addEventListener('cart:update', onUpdate);
      document.addEventListener('cart:error', onError);

      mainButton.click();

      setTimeout(function () {
        if (!settled) {
          settled = true;
          window.location.href = CART_URL;
        }
      }, 4000);
    },
    true
  );
})();
